import { useState } from 'react';
import { X, Zap } from 'lucide-react';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function AiTopUpModal({ open, onClose, usage, onPurchased }) {
  const [buying, setBuying] = useState(null);
  if (!open) return null;

  const packs = usage?.packs || [];

  const buy = async (packId) => {
    setBuying(packId);
    try {
      const r = await api.post('/api/billing/ai-packs/checkout', { pack: packId });
      const url = r.data?.checkout_url || r.data?.url;
      if (url) {
        window.location.href = url;
        return;
      }
      toast.error('Could not start checkout');
    } catch {
      toast.error('Checkout failed');
    } finally {
      setBuying(null);
      onPurchased?.();
    }
  };

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4 bg-black/70">
      <div className="w-full max-w-md rounded-2xl border border-slate-700 bg-slate-900 p-5 shadow-xl">
        <div className="flex items-start justify-between gap-3 mb-3">
          <div>
            <h2 className="text-lg font-semibold text-white">AI analyses used up</h2>
            <p className="text-slate-400 text-sm mt-1">
              Buy credits to keep running Claude property analyses. Desk reports stay unlimited.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-slate-500 hover:text-white p-1"
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>

        {(usage?.includedRemaining != null || usage?.creditBalance != null) && (
          <p className="text-xs text-slate-500 mb-3">
            Included left: {usage.includedRemaining ?? 0}
            {' · '}
            Credits: {usage.creditBalance ?? 0}
          </p>
        )}

        <div className="space-y-2">
          {packs.map((p) => (
            <button
              key={p.id}
              type="button"
              disabled={!!buying}
              onClick={() => buy(p.id)}
              className="w-full flex items-center justify-between rounded-xl border border-violet-500/30 bg-violet-500/10 hover:bg-violet-500/20 px-4 py-3 text-left disabled:opacity-50"
            >
              <span className="inline-flex items-center gap-2 text-white text-sm font-medium">
                <Zap size={14} className="text-violet-300" />
                {p.label || `${p.credits} analyses`}
              </span>
              <span className="text-violet-200 text-sm">
                {buying === p.id ? 'Opening…' : p.price}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
